import { MOVE_LAPSED_REASON, isLiveBooking } from '@atink/domain';
import type { Booking } from '@/domain/types';

/** How long a lapsed move stays on the Agent's alerts and Ops' list. */
export const MOVE_LAPSED_LOOKBACK_DAYS = 14;

/**
 * Top-up date moves that lapsed (B4, 75my; Anas 1 Oct Q4): the client didn't pay
 * the partial, so the server released the new AND the old date and kept the money
 * on file. Each one is the released OLD booking. The Agent is alerted to call back
 * and Ops sees it, until the client has a live booking again (or 14 days pass).
 */
export function lapsedMoveBookings(bookings: Record<string, Booking>, nowIso: string): Booking[] {
  const nowMs = Date.parse(nowIso);
  const all = Object.values(bookings);
  return all
    .filter(
      (b) =>
        b.status === 'cancelled' &&
        // The old date (the held new date is released with its own reason).
        b.cancelReason === MOVE_LAPSED_REASON &&
        !!b.cancelledAt &&
        nowMs - Date.parse(b.cancelledAt) <= MOVE_LAPSED_LOOKBACK_DAYS * 86_400_000,
    )
    .filter(
      (b) =>
        !all.some(
          (o) => o.customerId === b.customerId && o.id !== b.id && isLiveBooking(o) && Date.parse(o.createdAt) > Date.parse(b.cancelledAt!),
        ),
    )
    .sort((a, b) => b.cancelledAt!.localeCompare(a.cancelledAt!));
}
